import { Controller } from "@hotwired/stimulus";
import Plotly from "plotly.js-dist";

export default class extends Controller {
  static targets = ["graph", "slider", "momentLabel", "momentIndex", "prevButton", "nextButton"];
  static values = {
    config: Object,
  };

  connect() {
    this.currentIndex = this.configValue.moments.length - 1;
    this.updateButtonStates();
  }

  sliderChanged() {
    this.currentIndex = parseInt(this.sliderTarget.value, 10);
    this.updateGraph();
    this.updateButtonStates();
  }

  previous() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.sliderTarget.value = this.currentIndex;
      this.updateGraph();
      this.updateButtonStates();
    }
  }

  next() {
    if (this.currentIndex < this.configValue.moments.length - 1) {
      this.currentIndex++;
      this.sliderTarget.value = this.currentIndex;
      this.updateGraph();
      this.updateButtonStates();
    }
  }

  updateGraph() {
    const momentData = this.configValue.all_data[this.currentIndex];
    if (!momentData) return;

    this.momentLabelTarget.textContent = momentData.label;
    this.momentIndexTarget.textContent = this.currentIndex + 1;

    Plotly.react(this.graphTarget, momentData.traces, this.graphTarget.layout);
  }

  updateButtonStates() {
    if (this.hasPrevButtonTarget) {
      this.prevButtonTarget.disabled = this.currentIndex === 0;
    }
    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.disabled = this.currentIndex === this.configValue.moments.length - 1;
    }
  }
}
